import { z } from 'zod/v4'

/**
 * interface for Stripe payment link collection
 */
export const BasePaymentLinkValidator = z.object({
	interval: z.enum(['monthly', 'annual']),
	link: z.string(),
	quantity: z.number(),
	product: z.string(),
	name: z.string(),
})

export const PaymentLinkValidator = BasePaymentLinkValidator.extend({
	id: z.string(),
})

export type BasePaymentLink = z.infer<typeof BasePaymentLinkValidator>
export type PaymentLink = z.infer<typeof PaymentLinkValidator>
